import { useState } from "react"
import { TextWithSearch } from "../../components/inputs/text/TextWithSearch"
import { Buttom } from "../../components/buttom/buttom"
import { Loading } from "../../components/loading/loading"
import { SubscriptionMenu } from "./SubscriptionControl/SubscriptionMenu"
import { getCompanies } from "../../services/Signature/Signature"
import { FaBuilding } from "react-icons/fa"
import { Mask } from "utils/mask"

export const Signature = () => {
  const [showOptions, setShowCompanies] = useState<boolean>(false)
  const [companies, setCompanies] = useState<{
    empresa: {
      id: number
      nome: string
    }
  }[] | []>([])
  const [companySelected, setCompanySelected] = useState<{
    objectId: string | undefined,
  }>()
  const [isButtonDisabled, setButtonDisabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const [subscriptionControl, setSubscriptionControl] = useState(false)
  const [state, setState] = useState({ nome: "" })

  const handleSearch = async () => {

    setLoading(true)
    try {
      setButtonDisabled(true)
      const response = await getCompanies({ nome: new Mask().removeCpfCnpjMask(state["nome"]) })
      response.filter((item: any) => item.plano?.nome !== "FREE")
      setShowCompanies(true)
      setCompanies(response)
    } catch (error: any) { alert(error.response.data.message || "Algum erro aconteceu!") }
    setLoading(false)
  }

  return (
    <>
      {!subscriptionControl &&
        <div >
          <div className='row'>
            <div className='col-12'>
              <h1 className='text-center'>Controle de assinaturas</h1>
            </div>
          </div>
          <div className='justify-content-center d-flex'>
            <TextWithSearch id='input-text-signature' type="text" label="Qual fábrica?" required={true} name="nome" state={state} setState={setState} handleSearch={handleSearch} />
          </div>
          {loading ? (
            <Loading />
          ) : (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                  gap: "20px",
                  width: "100%",
                  marginTop: "20px",
                }}
              >
                {showOptions &&
                  companies.map((item: any, index: number) => {
                    const isSelected =
                      companySelected?.objectId === item.objectId
                    return (
                      <div
                        key={`key-div-${index}`}
                        onClick={() => {
                          setButtonDisabled(false)
                          setCompanySelected(item)
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className={`card ${isSelected
                            ? "shadow"
                            : "border-light shadow-sm"
                            }`}
                          style={{
                            borderRadius: "12px",
                            transition: "all 0.2s ease",
                            minWidth: "100%",
                            backgroundColor: isSelected
                              ? "rgba(13, 110, 253, 0.05)"
                              : "#fff",
                          }}
                        >
                          <div className="card-body d-flex align-items-center p-3">

                            {/* Radio */}
                            <div className="form-check me-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="options-inline"
                                id={`option-${index}`}
                                value={`option-${index}`}
                                checked={isSelected}
                                onChange={() => {
                                  setButtonDisabled(false)
                                  setCompanySelected(item)
                                }}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </div>

                            {/* Ícone */}
                            <div
                              className={`d-flex align-items-center justify-content-center me-3 ${isSelected
                                ? "text-white"
                                : "bg-opacity-10 text-primary"
                                }`}
                              style={{
                                width: "48px",
                                height: "48px",
                                minWidth: "48px",
                                borderRadius: "10px",
                              }}
                            >
                              <FaBuilding size={24} color="#332E19" />
                            </div>

                            {/* Informações */}
                            <div className="flex-grow-1">
                              <div className="fw-bold fs-6">
                                {item.empresa.nome}
                              </div>
                              <div className="text-muted small mt-1">
                                <i className="bi bi-calendar3 me-1"></i>
                                CNPJ:{" "}
                                {new Mask().cpf_cnpj(
                                  item.empresa.cpf_cnpj
                                )}
                              </div>
                              <div className="text-muted small mt-1">
                                <i className="bi bi-calendar3 me-1"></i>
                                Nome Fantasia:{" "}
                                {item.empresa.nome_fantasia}
                              </div>
                              <div className="text-muted small mt-1">
                                <i className="bi bi-calendar3 me-1"></i>
                                Proprietário:{" "}
                                {item.proprietario?.nome}
                              </div>
                              <div className="text-muted small mt-1">
                                <i className="bi bi-calendar3 me-1"></i>
                                Plano:{" "}
                                {item.plano?.nome}
                              </div>
                              <div className="text-muted small mt-1">
                                <i className="bi bi-calendar3 me-1"></i>
                                Data de criação:{" "}
                                {new Date(
                                  item.empresa.createdAt
                                ).toLocaleDateString("pt-BR")}
                              </div>

                            </div>

                            {/* Indicador */}
                            <div className="ms-3">
                              {isSelected ? (
                                <i className="bi bi-check-circle-fill text-primary fs-5"></i>
                              ) : (
                                <i className="bi bi-chevron-right text-muted"></i>
                              )}
                            </div>

                          </div>
                        </div>
                      </div>
                    )
                  })}
              </div>

              {showOptions && (
                <div className="row justify-content-center m-2">
                  <Buttom
                    text="Selecionar"
                    id="btn-select"
                    onClick={() => {
                      setShowCompanies(false)
                      setSubscriptionControl(true)
                    }}
                    disabled={isButtonDisabled}
                  />
                </div>
              )}
            </>
          )}
        </div >
      }
      {subscriptionControl && <SubscriptionMenu companySelected={companySelected} setCompanySelected={setCompanySelected} setSubscriptionControl={setSubscriptionControl} />}
    </>
  )
}